import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ANSWER_OPTIONS } from './constants';
import { AnswerKeyRow } from './answer-key-row';

const useStyles = makeStyles(() => ({
  headerCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}));

export function AnswerKeyTable({ answerKey, editing, givenAnswers, onSelect, disabled }) {
  const classes = useStyles();

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Questão</TableCell>
          {ANSWER_OPTIONS.map((letter) => (
            <TableCell key={letter} className={classes.headerCell} align="center">
              {letter}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {answerKey.map((question) => (
          <AnswerKeyRow
            key={question.questionId}
            question={question}
            editing={editing}
            selectedOptionId={givenAnswers[question.questionId]}
            onSelect={onSelect}
            disabled={disabled}
          />
        ))}
      </TableBody>
    </Table>
  );
}
